import React from 'react';
import {Col, Row} from 'antd';
import {WarningOutlined} from '@ant-design/icons';
import {connect} from 'react-redux';
import Styled from './index.style';

function StoreNotFound() {
    return (
        <Styled>
            <Row className="not-found-row" align="middle">
                <Col span={24} align="center">
                    <p><WarningOutlined /></p>
                    <h2>Store Not Found</h2>
                </Col>
            </Row>
        </Styled>
    );
}

export default connect()(StoreNotFound);
